var _g, _defs;

var _excluded = ["title", "titleId"];

function _extends() { _extends = Object.assign || function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }

function _objectWithoutProperties(source, excluded) { if (source == null) return {}; var target = _objectWithoutPropertiesLoose(source, excluded); var key, i; if (Object.getOwnPropertySymbols) { var sourceSymbolKeys = Object.getOwnPropertySymbols(source); for (i = 0; i < sourceSymbolKeys.length; i++) { key = sourceSymbolKeys[i]; if (excluded.indexOf(key) >= 0) continue; if (!Object.prototype.propertyIsEnumerable.call(source, key)) continue; target[key] = source[key]; } } return target; }

function _objectWithoutPropertiesLoose(source, excluded) { if (source == null) return {}; var target = {}; var sourceKeys = Object.keys(source); var key, i; for (i = 0; i < sourceKeys.length; i++) { key = sourceKeys[i]; if (excluded.indexOf(key) >= 0) continue; target[key] = source[key]; } return target; }

import * as React from "react";

function SvgFreeDashboardCard(_ref, svgRef) {
  var title = _ref.title,
      titleId = _ref.titleId,
      props = _objectWithoutProperties(_ref, _excluded);

  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 242,
    height: 147,
    viewBox: "0 0 242 147",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _g || (_g = /*#__PURE__*/React.createElement("g", {
    clipPath: "url(#clip0_5483_3079)"
  }, /*#__PURE__*/React.createElement("path", {
    opacity: 0.18,
    d: "M241.644 126.408C241.41 129.842 239.42 133.158 235.948 136.358C232.709 139.284 228.222 142.093 222.681 144.708H19.9031C15.8061 141.976 12.2945 138.66 9.29008 134.563C8.23659 133.08 7.26113 131.559 6.40272 129.998C-18.8421 84.0342 41.1681 -3.83511 61.3405 0.495922C70.5879 2.48586 65.1253 22.5413 80.3815 32.2959C109.255 50.7125 164.427 1.66647 180.698 16.4154C189.399 24.2971 174.845 39.5143 180.268 62.8863C189.516 102.49 242.893 107.601 241.644 126.408Z",
    fill: "#F2F7FA"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M33.3654 112.986C31.2584 114 28.4101 111.776 27.2785 110.879C25.5227 109.513 24.3912 107.914 20.9966 100.578C17.8361 93.6718 17.9141 93.0865 18.1873 92.8524C19.2408 91.916 23.2597 94.9984 29.0734 99.4465C33.6385 102.958 34.7701 104.363 35.2383 106.236C35.8626 108.616 35.3944 112.049 33.3654 112.986Z",
    fill: "#CCE0EB"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M64.0719 115.171C63.6817 116.107 59.0385 113.337 53.9271 114.859C49.0498 116.342 48.6206 120.243 44.2506 120.712C42.4167 120.907 40.2707 120.399 38.9051 119.463C38.3198 119.034 37.8906 118.527 37.6955 117.98C36.759 115.171 41.4022 110.489 46.2405 109.006C51.8201 107.289 56.9705 110.099 59.8579 111.659C60.7943 112.167 61.8478 112.83 62.7062 113.454C63.5646 114.118 64.228 114.781 64.0719 115.171Z",
    fill: "#CCE0EB"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M31.3365 120.243C30.8682 121.141 28.215 120.985 26.3031 120.126C25.1325 119.58 24.9374 119.073 24.1571 118.605C20.7625 116.693 15.378 121.375 14.9878 120.868C14.5976 120.321 19.2408 113.337 24.8984 114.196C28.8393 114.82 31.9607 118.995 31.3365 120.243Z",
    fill: "#CCE0EB"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M37.7355 144.786H32.8582C30.5171 144.786 28.6442 142.874 28.6442 140.572L26.8103 124.34H43.7833L41.9494 140.572C41.9494 142.913 40.0766 144.786 37.7355 144.786Z",
    fill: "#E6EFF5"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M38.0476 144.786H32.8582C30.5171 144.786 28.6442 142.874 28.6442 140.572L26.8103 124.34H28.176L33.4044 140.572C34.1848 142.835 35.7065 144.786 38.0476 144.786Z",
    fill: "#CCE0EB"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M34.3404 124.457C34.8867 122.038 35.4329 118.448 33.9893 113.493C33.9112 113.22 33.8332 112.986 33.7551 112.752C32.5066 109.006 28.9949 104.714 26.2246 101.319",
    stroke: "#CCE0EB",
    strokeWidth: 0.347,
    strokeMiterlimit: 10
  }), /*#__PURE__*/React.createElement("path", {
    d: "M34.3418 124.457C35.7465 122.545 39.8434 117.629 44.9938 114.274C47.7641 112.479 49.715 111.971 51.5099 111.932C52.8365 111.893 53.929 112.167 54.6704 112.401",
    stroke: "#CCE0EB",
    strokeWidth: 0.347,
    strokeMiterlimit: 10
  }), /*#__PURE__*/React.createElement("path", {
    d: "M34.3413 124.34C32.1562 121.336 29.8151 119.502 28.2934 118.488C25.6402 116.732 24.1185 116.537 23.221 116.498C21.8554 116.459 20.7629 116.81 20.0605 117.122",
    stroke: "#CCE0EB",
    strokeWidth: 0.347,
    strokeMiterlimit: 10
  }), /*#__PURE__*/React.createElement("path", {
    d: "M134.695 49.0346C138.811 49.0346 142.147 45.698 142.147 41.5821C142.147 37.4662 138.811 34.1296 134.695 34.1296C130.579 34.1296 127.242 37.4662 127.242 41.5821C127.242 45.698 130.579 49.0346 134.695 49.0346Z",
    fill: "#CCE0EB"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M146.556 40.9189H140.742H127.476H121.662C120.687 40.9189 120.024 39.9824 120.336 39.046L126.657 20.6684L127.086 19.3808C127.281 18.8345 127.71 18.4443 128.217 18.2882C128.373 18.2492 128.53 18.2102 128.686 18.2102H139.533C140.274 18.2102 140.898 18.6784 141.132 19.3417L147.883 39.007C148.195 39.9824 147.492 40.9189 146.556 40.9189Z",
    fill: "#E6EFF5"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M134.694 -10H133.523V18.2493H134.694V-10Z",
    fill: "#E6EFF5"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M138.478 18.2493H129.738C129.738 16.8446 130.909 15.6741 132.313 15.6741H135.864C137.308 15.6741 138.478 16.8446 138.478 18.2493Z",
    fill: "#E6EFF5"
  }), /*#__PURE__*/React.createElement("path", {
    opacity: 0.5,
    d: "M146.555 40.9189H140.742H139.571C140.117 40.0995 141.717 39.9824 142.81 38.7729C145.97 35.1832 143.317 23.6338 135.318 19.7319C134.772 19.4588 131.728 18.0541 128.256 18.2882C128.412 18.2492 128.568 18.2102 128.724 18.2102H139.571C140.313 18.2102 140.937 18.6784 141.171 19.3417L147.921 39.007C148.194 39.9824 147.492 40.9189 146.555 40.9189Z",
    fill: "#CCE0EB"
  }), /*#__PURE__*/React.createElement("path", {
    opacity: 0.22,
    d: "M85.5328 17.0007V76.5427C85.5328 79.6252 82.5675 82.1614 78.9388 82.1614H33.1312C31.8046 82.1614 30.595 81.8492 29.5805 81.2639C27.7857 80.2495 26.5761 78.5327 26.5761 76.5427V17.0007C26.5761 15.0498 27.7857 13.294 29.5805 12.2795C30.595 11.6942 31.8436 11.3821 33.1312 11.3821H78.9388C82.5675 11.4211 85.5328 13.9183 85.5328 17.0007Z",
    fill: "#CCE0EB"
  }), /*#__PURE__*/React.createElement("path", {
    opacity: 0.08,
    d: "M85.5328 34.5591V76.5818C85.5328 79.6643 82.5675 82.2005 78.9387 82.2005H33.1312C29.5025 82.2005 26.5371 79.6643 26.5371 76.5818V47.9814C29.8927 45.2501 34.1067 42.987 38.5548 43.3772C44.7587 43.8845 44.8367 48.8788 50.9626 50.2835C63.0193 53.0148 75.7002 36.9002 85.5328 34.5591Z",
    fill: "#E6EFF5"
  }), /*#__PURE__*/React.createElement("path", {
    opacity: 0.22,
    d: "M29.7366 12.9038V80.6787C29.7366 80.8738 29.6976 81.0689 29.5805 81.264C27.7857 80.2495 26.5761 78.5327 26.5761 76.5428V17.0008C26.5761 15.0498 27.7857 13.294 29.5805 12.2795C29.6976 12.4746 29.7366 12.6697 29.7366 12.9038Z",
    fill: "#CCE0EB"
  }), /*#__PURE__*/React.createElement("path", {
    opacity: 0.22,
    d: "M60.0543 12.5137V80.2885C60.0543 81.1079 59.2739 81.7712 58.2985 81.7712H57.9863V11.4211H59.469C59.8202 11.6943 60.0543 12.0845 60.0543 12.5137Z",
    fill: "#CCE0EB"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M85.5328 32.2959H26.5761V35.1052H85.5328V32.2959Z",
    fill: "white"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M85.5328 26.7163H26.5761V29.5256H85.5328V26.7163Z",
    fill: "white"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M85.5328 21.1367H26.5761V23.946H85.5328V21.1367Z",
    fill: "white"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M85.5328 15.5571H26.5761V18.3664H85.5328V15.5571Z",
    fill: "white"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M57.9469 11.4211H54.1231V81.8102H57.9469V11.4211Z",
    fill: "white"
  }), /*#__PURE__*/React.createElement("path", {
    opacity: 0.42,
    d: "M238.25 146.151C238.25 146.503 238.094 146.815 237.86 147.049C237.626 147.283 237.275 147.4 236.884 147.4H20.3326C19.5912 147.4 18.9669 146.854 18.9669 146.151C18.9669 145.8 19.123 145.488 19.3571 145.254C19.5912 145.02 19.9424 144.903 20.3326 144.903H236.884C237.626 144.903 238.25 145.449 238.25 146.151Z",
    fill: "#E6EFF5"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M209.524 97.8307L205.953 98.8259L212.239 121.378L215.81 120.382L209.524 97.8307Z",
    fill: "#CCE0EB"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M209.533 97.8079L205.943 98.8224L206.021 94.1402L206.06 92.6575L206.88 93.9061L209.533 97.8079Z",
    fill: "#CCE0EB"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M206.919 93.9061L206.06 94.1402V92.6575L206.919 93.9061Z",
    fill: "#CCE0EB"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M224.595 131.754L217.533 132.534L213.514 96.9884L220.576 96.208L224.595 131.754Z",
    fill: "#CCE0EB"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M229.51 97.6908C232.046 96.9494 232.319 94.6473 232.319 94.6473C233.255 90.3553 227.793 86.7656 227.793 86.7656C227.793 86.7656 228.027 89.8481 225.764 91.1357C223.54 92.4233 224.437 96.4812 225.569 96.7153",
    fill: "#CCE0EB"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M229.46 97.6158L225.613 96.759L225.062 99.2346L228.909 100.091L229.46 97.6158Z",
    fill: "#E6EFF5"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M221.823 122.74C221.277 122.623 220.965 122.116 221.043 121.57L225.062 99.2124L228.925 100.071L223.072 122.038C222.877 122.545 222.37 122.897 221.823 122.74Z",
    fill: "#CCE0EB"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M229.394 115.522L223.385 145.176L223.346 145.293L223.307 145.41H212.85L207.193 115.522C207.115 115.054 207.349 114.664 207.739 114.469C207.778 114.43 207.856 114.43 207.934 114.391C208.012 114.352 208.09 114.352 208.168 114.352H228.419C229.082 114.352 229.55 114.937 229.394 115.522Z",
    fill: "#E6EFF5"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M223.385 145.254L223.346 145.371H212.889L207.232 115.483C207.154 115.015 207.388 114.625 207.778 114.43C207.817 114.391 207.895 114.391 207.973 114.352C212.304 124.574 214.099 131.286 214.918 135.812C215.152 137.216 215.582 139.909 217.689 142.172C219.366 144.045 221.512 144.864 223.385 145.254Z",
    fill: "#CCE0EB"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M175.586 85.2049V138.387H72.3828V85.2049C72.3828 80.7958 76.3627 77.2451 81.24 77.2451H166.69C171.606 77.2451 175.586 80.7958 175.586 85.2049Z",
    fill: "#31414E"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M171.88 139.089H76.0508V86.9608C76.0508 83.4101 78.9381 80.5618 82.4498 80.5618H165.442C168.992 80.5618 171.841 83.4491 171.841 86.9608V139.089H171.88Z",
    fill: "white"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M183.586 144.747H65.9456C64.1898 144.747 62.7852 143.303 62.7852 141.586C62.7852 139.83 64.2288 138.426 65.9456 138.426H183.586C185.342 138.426 186.746 139.869 186.746 141.586C186.746 143.303 185.342 144.747 183.586 144.747Z",
    fill: "#31414E"
  }), /*#__PURE__*/React.createElement("rect", {
    x: 82,
    y: 86,
    width: 40,
    height: 23,
    rx: 3,
    fill: "#F2F7FA"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M102.428 102.856C105.426 102.856 107.856 100.426 107.856 97.428C107.856 94.4302 105.426 92 102.428 92C99.4302 92 97 94.4302 97 97.428C97 100.426 99.4302 102.856 102.428 102.856Z",
    fill: "#28C18A"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M100.242 97.6038L101.75 99.5639L105.218 95.8447",
    stroke: "#F2F7FA",
    strokeWidth: 1.28808,
    strokeMiterlimit: 10,
    strokeLinecap: "round",
    strokeLinejoin: "round"
  }), /*#__PURE__*/React.createElement("rect", {
    x: 127,
    y: 86,
    width: 40,
    height: 48,
    rx: 3,
    fill: "#F2F7FA"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M147.428 115.856C150.426 115.856 152.856 113.426 152.856 110.428C152.856 107.43 150.426 105 147.428 105C144.43 105 142 107.43 142 110.428C142 113.426 144.43 115.856 147.428 115.856Z",
    fill: "#28C18A"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M145.242 110.604L146.75 112.564L150.218 108.845",
    stroke: "#F2F7FA",
    strokeWidth: 1.28808,
    strokeMiterlimit: 10,
    strokeLinecap: "round",
    strokeLinejoin: "round"
  }), /*#__PURE__*/React.createElement("rect", {
    x: 82,
    y: 111,
    width: 40,
    height: 23,
    rx: 3,
    fill: "#F2F7FA"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M102.428 127.856C105.426 127.856 107.856 125.426 107.856 122.428C107.856 119.43 105.426 117 102.428 117C99.4302 117 97 119.43 97 122.428C97 125.426 99.4302 127.856 102.428 127.856Z",
    fill: "#28C18A"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M100.242 122.604L101.75 124.564L105.218 120.845",
    stroke: "#F2F7FA",
    strokeWidth: 1.28808,
    strokeMiterlimit: 10,
    strokeLinecap: "round",
    strokeLinejoin: "round"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M60.4035 58.7114C67.4501 58.7114 73.1625 52.999 73.1625 45.9524C73.1625 38.9058 67.4501 33.1934 60.4035 33.1934C53.3569 33.1934 47.6445 38.9058 47.6445 45.9524C47.6445 52.999 53.3569 58.7114 60.4035 58.7114Z",
    fill: "#CCE0EB"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M60.4037 53.5609C61.632 53.5609 62.6278 52.5651 62.6278 51.3368C62.6278 50.1085 61.632 49.1128 60.4037 49.1128C59.1754 49.1128 58.1797 50.1085 58.1797 51.3368C58.1797 52.5651 59.1754 53.5609 60.4037 53.5609Z",
    fill: "white"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M66.1388 51.1419H54.6284C54.0431 51.1419 53.731 50.4785 54.0431 50.0103L55.3307 48.2545C55.4478 48.0594 55.5258 47.8253 55.5258 47.6302V43.5333C55.5258 42.1286 56.0721 40.841 56.9305 39.9046C57.7889 38.9681 59.0375 38.4219 60.3641 38.4219C63.0174 38.4219 65.2024 40.724 65.2024 43.5333V47.6302C65.2024 47.8643 65.2804 48.0984 65.3975 48.2545L66.6851 50.0103C67.0753 50.4785 66.7241 51.1419 66.1388 51.1419Z",
    fill: "white"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M196 37.5C196 37.5 180.149 39.8371 179.5 50C179.116 56.0156 189.687 58.5114 189 64.5C188.274 70.8337 174 72.5 174 72.5",
    stroke: "#28C18A",
    strokeWidth: 2,
    strokeLinecap: "round",
    strokeDasharray: "5 5"
  }), /*#__PURE__*/React.createElement("g", {
    clipPath: "url(#clip1_5483_3079)"
  }, /*#__PURE__*/React.createElement("path", {
    d: "M212.596 21.191C216.036 19.4988 220.467 18.9115 220.884 18.8585L220.226 13.9803L213.995 17.5056C213.271 17.9148 212.791 18.6637 212.727 19.5021L212.596 21.191ZM224.763 27.1338C224.763 27.1338 221.647 31.121 218.339 32.9925C210.03 37.6929 205.248 35.1991 204.2 34.5324C204.156 33.2878 204.494 27.9074 212.803 23.2069C216.111 21.3355 221.133 20.7179 221.133 20.7179L224.763 27.1338ZM219.96 34.2076C223.183 32.1307 225.968 28.6355 226.228 28.3055L230.071 31.3819L223.839 34.9073C223.116 35.3164 222.227 35.3422 221.476 34.9651L219.96 34.2076ZM226.693 24.8541C227.692 25.1314 228.709 24.9724 229.54 24.5023C231.356 23.4752 233.849 17.7587 233.849 17.7587C233.849 17.7587 227.665 16.9515 225.849 17.9787C225.202 18.3425 224.678 18.8903 224.343 19.5527C224.008 20.2151 223.877 20.9621 223.968 21.6988C224.058 22.4356 224.365 23.1289 224.851 23.6906C225.336 24.2524 225.977 24.6574 226.693 24.8541ZM214.515 26.6655C213.19 26.2981 211.806 27.0815 211.438 28.4065C211.071 29.7314 211.854 31.1162 213.179 31.4837C214.504 31.8512 215.889 31.0677 216.256 29.7428C216.624 28.4178 215.84 27.033 214.515 26.6655Z",
    fill: "#28C18A"
  })))), _defs || (_defs = /*#__PURE__*/React.createElement("defs", null, /*#__PURE__*/React.createElement("clipPath", {
    id: "clip0_5483_3079"
  }, /*#__PURE__*/React.createElement("rect", {
    width: 242,
    height: 147,
    fill: "white"
  })), /*#__PURE__*/React.createElement("clipPath", {
    id: "clip1_5483_3079"
  }, /*#__PURE__*/React.createElement("rect", {
    width: 30,
    height: 30,
    fill: "white",
    transform: "matrix(-0.267259 0.963625 0.963625 0.267259 208.018 8)"
  })))));
}

var ForwardRef = /*#__PURE__*/React.forwardRef(SvgFreeDashboardCard);
export default __webpack_public_path__ + "static/media/free-dashboard-card.4ad5792c3a9f70bf1359ed15a5940dee.svg";
export { ForwardRef as ReactComponent };